var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-info text-center mt-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('em',{staticClass:"no-info__icon",class:_vm.icon})]),_c('div',{staticClass:"col-12 mt-2"},[_c('span',{staticClass:"no-info__text"},[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }